import React from "react";
import { Route } from "react-router-dom";
import AgroExpertMain from "../../screens/agro_expert/AgroExperMain";
import DetailedQuestion from "../../screens/agro_expert/DetailedQuestion";

export const agroExpertRoutes = [
  <Route key="agro-expert-home" path="/" element={<AgroExpertMain />} />,
  <Route
    key="unanswered-question"
    path="/unanswered/:id"
    element={<DetailedQuestion context="unanswered" />}
  />,
  <Route
    key="answered-question"
    path="/answered/:id"
    element={<DetailedQuestion context="answered" />}
  />,
];
